import { BADGE_VARIANT } from '@shared/ui/badge';

import { CARD_STATUS } from './cardStatusConfig';
import { Translation } from './i18n';

export const CARD_STATUS_BADGE_CONFIG = {
	[CARD_STATUS.toActivate]: {
		variant: BADGE_VARIANT.softOrange,
		labelKey: Translation.CARD_STATUS_TO_ACTIVATE,
	},
	[CARD_STATUS.requested]: {
		variant: BADGE_VARIANT.softWarm,
		labelKey: Translation.CARD_STATUS_REQUESTED,
	},
	[CARD_STATUS.ordered]: {
		variant: BADGE_VARIANT.softLime,
		labelKey: Translation.CARD_STATUS_ORDERED,
	},
	[CARD_STATUS.produced]: {
		variant: BADGE_VARIANT.softBlue,
		labelKey: Translation.CARD_STATUS_PRODUCED,
	},
	[CARD_STATUS.frozen]: {
		variant: BADGE_VARIANT.softViolet,
		labelKey: Translation.CARD_STATUS_FROZEN,
	},
	[CARD_STATUS.faulty]: {
		variant: BADGE_VARIANT.softRed,
		labelKey: Translation.CARD_STATUS_FAULTY,
	},
	[CARD_STATUS.active]: {
		variant: BADGE_VARIANT.softGreen,
		labelKey: Translation.CARD_STATUS_ACTIVE,
	},
};

